import { render, staticRenderFns } from "./ReceipesRegular.vue?vue&type=template&id=e1eb6970&scoped=true&"
import script from "./ReceipesRegular.vue?vue&type=script&lang=js&"
export * from "./ReceipesRegular.vue?vue&type=script&lang=js&"
import style0 from "./ReceipesRegular.vue?vue&type=style&index=0&id=e1eb6970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1eb6970",
  null
  
)

export default component.exports